module.exports = __webpack_public_path__ + "static/media/avatar-5.c8f9977a.png";